import React, { ReactElement, useEffect, useState } from 'react';
import { Client, ModeleHoraire } from '../../../../../common/src/entities';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { ChampsModeleHoraire } from './DetailsModeleHoraire';
import { useNavigate } from 'react-router-dom';

const MODELE_HORAIER_CREER_INCONNU = "Création d'un nouveau modèle d'horaire";
const MODELE_HORAIRE_CREER_CONNU = "Création du modèle d'horaire ";
const ALERT_MODELE_HORAIRE = "Modèle d'horaire";
const ALERT_CREER_SUCESS = 'créé(e) avec succès!';

/**
 * Page de création d'une entité ModeleHoraire contenant les boutons
 * du haut et le formulaire à remplir
 *
 * @returns page html du formulaire
 */
export default function CreerModeleHoraire(props: Partial<PropsDeCreationEntite<ModeleHoraire>>): ReactElement {
    const bsAlert = useAlertDialog();
    const navigate = useNavigate();

    const [valeursInitiales, setValeursInitiales] = useState<ModeleHoraire>(new ModeleHoraire());

    useEffect(() => {
        let title = "Nouveau modèle d'horaire - Dashboard";
        if (valeursInitiales.name) {
            title = `${valeursInitiales.name} - Dashboard`;
        }
        document.title = title;
    }, [valeursInitiales.name]);

    /**
     * Affiche le titre en haut du formulaire de création du client
     *
     * @param c entité Client
     * @returns html du titre
     */
    function texteEntete(c: Client): JSX.Element {
        return (
            <>
                <small className="text-muted">
                    {c.name ? MODELE_HORAIRE_CREER_CONNU : MODELE_HORAIER_CREER_INCONNU}
                </small>
                {c.name && c.name}
            </>
        );
    }

    /**
     * Callback pour un formulaire envoyé à la BD avec succès.
     * Affiche le popup de confirmation la première fois ensuite
     * seulement un crochet dans le bouton Sauvegarder
     *
     * @param c entité ModeleHoraire
     */
    function gererSucces(c: ModeleHoraire): void {
        if (valeursInitiales.id === undefined)
            bsAlert(`${ALERT_MODELE_HORAIRE} ${c.name} ${ALERT_CREER_SUCESS}`, 'success');
        setValeursInitiales(c);

        navigate('/dashboard/modeles-horaire/' + c.id, { replace: true });
    }

    /**
     * Callback pour netoyer l'objet à envoyer afin de respecter l'entité de la BD.
     *
     * @param c entité ModeleHoraire
     */
    function nettoyer(c: ModeleHoraire): void {
        if (c.modeleHoraireActivite[0] !== null) c.modeleHoraireActivite?.forEach((ae) => delete ae.activite['label']);
        if (c.modeleHoraireProduit[0] !== null) c.modeleHoraireProduit?.forEach((ae) => delete ae.produit['label']);
    }

    return (
        <FormulaireCreationEntite
            texteEntete={texteEntete}
            entite={ModeleHoraire}
            nettoyer={nettoyer}
            succes={gererSucces}
            valeursInitiales={valeursInitiales}
            aussiEnvoyerCreated_at
            properties_to_reassign={{ id: 'id' }}
            {...props}
        >
            <ChampsModeleHoraire />
        </FormulaireCreationEntite>
    );
}
